import { IDmLoaiThuChiActionTypes } from "../../action-types/category/IDmLoaiThuChiActions";
import { IDmLoaiThuChiReducer } from "../../reducer-model/category/IDmLoaiThuChiReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IDmLoaiThuChiReducer = {
  status: eReducerStatusBase.is_not_initialization,
  loaiThuChis: [],
  idSelections: [],
};
export const loaiThuChiReducer = (
  state: IDmLoaiThuChiReducer = iniState,
  action: IDmLoaiThuChiActionTypes
): IDmLoaiThuChiReducer => {
  switch (action.type) {
    case "LOAI_THU_CHI_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        idSelections: [],
      };
    case "LOAI_THU_CHI_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        loaiThuChis: action.payload?.sort((a, b) => a.stt - b.stt),
      };
    case "LOAI_THU_CHI_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_CHI_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "LOAI_THU_CHI_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "LOAI_THU_CHI_SAVE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_CHI_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "LOAI_THU_CHI_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "LOAI_THU_CHI_DELETE_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "LOAI_THU_CHI_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        loaiThuChiEditing: action.payload,
      };
    case "LOAI_THU_CHI_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
        loaiThuChiEditing: undefined,
      };
    case "LOAI_THU_CHI_SELECTED_ID":
      return {
        ...state,
        idSelections: action.payload,
      };
    case "LOAI_THU_CHI_DELETE_MANY_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "LOAI_THU_CHI_DELETE_MANY_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "LOAI_THU_CHI_DELETE_MANY_ERROR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
